<template>
    <div class="gallery--images">
        <draggable v-model="localItem.media" @end="saveOrder()">
            <div v-for="image in localItem.media" :key="image.id">
                <div class="single--image">
                    <a class="remove--image" href="#" @click.prevent="attemptDelete(image)">
                        <i class="fal fa-times"></i>
                    </a>
                    <img :src="image.url">
                    <a v-if="image.custom_properties.cover" disabled="">Current Cover</a>
                    <a href="#" @click.prevent="setCover(image)" v-else>Set Cover</a>
                </div>
            </div>
        </draggable>
    </div>
</template>
<script>
    import draggable from 'vuedraggable'
    export default {
        props: ['item', 'activityUuid'],

        components: {
            draggable,
        },

        data () {
            return {
                localItem: {
                    media: []
                }
            }
        },

        computed: {
            mediaIds () {
                return this.localItem.media.map((item) => item.id)
            }
        },

        watch: {
            item (value) {
                this.localItem = value
            }
        },

        methods: {
            setCover (media) {
              window.axios.post(`/activities/${this.activityUuid}/${this.localItem.uuid}/${media.id}/cover`, {}).then((response) => {
                  this.$emit('updated', response.data)
                  this.$toasted.show('The cover was changed', {
                    icon: 'info'
                  })
              })
            },

            attemptDelete (media) {
                this.$swal({
                  title: 'Are you sure you want to delete this image?',
                  text: 'This data cannot be restored.',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, delete!',
                  cancelButtonText: 'Do not delete.'
                }).then((result) => {
                    if (result.value) {
                        this.delete(media)
                    }
                })
            },

            delete (media) {
              window.axios.delete(`/activities/${this.activityUuid}/${this.localItem.uuid}/${media.id}`, {}).then((response) => {
                  this.$emit('updated', response.data)
                  this.$toasted.show('The image was deleted', {
                    icon: 'info'
                  })
              })
            },

            saveOrder () {
                window.axios.post(`/activities/${this.activityUuid}/${this.localItem.uuid}/media-order`, {ordered: this.mediaIds}).then((response) => {
                    this.$emit('updated', response.data)
                    this.localItem.media = this.response.data.media
                })
            }
        }
    }
</script>
